/* component-localization.js — country/region and language selectors */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-localization-select]').forEach(function (select) {
      if (select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';

      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
